module.exports = __webpack_public_path__ + "img/coctail-1.a84f1194.png";